import React from 'react'
import styled from 'styled-components'

import { mainText } from 'assets/styles/variables'

type Props = {
  handleClickNewUser: () => void
}

export const InviteNewUserInput: React.FC<Props> = ({ handleClickNewUser }) => {
  return (
    <Container>
      <Message>
        Can&apos;t find who you&apos;re looking for?{' '}
        <FakeLink onClick={handleClickNewUser}>Invite new user to hub</FakeLink>
      </Message>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 5px 0;
`

const Message = styled.div`
  color: ${mainText};
`

const FakeLink = styled.span`
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
`
